import ProductSinglePre from "./components/product-single/pre-index";

const productSinglePre = new ProductSinglePre();
productSinglePre.init();
